import { render } from "./CommonSettings.vue?vue&type=template&id=4d3d1a0a"
import script from "./CommonSettings.vue?vue&type=script&lang=js"
export * from "./CommonSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__